// @ts-check
/**
 * @file api/push.js
 * @location src/integrations/supabase/api/push.js
 * @role push_subscriptions 관련 RPC 래퍼 + push-send Edge Function 호출.
 *
 *  push subscription 은 서버가 소유 — 클라이언트 캐시 X (재구독은 browser API 가 보장).
 *  wrappedAct/outbox 경유 X — server-of-record 자원.
 */
import { supabase } from '../client.js';
import { callRpc } from './_call.js';

export async function addPushSubscription({ endpoint, p256dh, auth, user_agent }) {
  await callRpc('rpc_add_push_subscription', {
    p_endpoint: endpoint,
    p_p256dh: p256dh,
    p_auth: auth,
    p_user_agent: user_agent,
  }, (d) => d);
}

export async function deletePushSubscription({ endpoint }) {
  await callRpc('rpc_delete_push_subscription', { p_endpoint: endpoint }, (d) => d);
}

/**
 * push-send Edge Function 호출 — fire-and-forget.
 * 실패해도 throw 하지 않음(개별 알림 실패가 task 발신을 막지 않음).
 *
 * @param {{ memberId: string, taskId?: string, title: string, body?: string, url?: string }} payload
 */
export async function sendPushNotification(payload) {
  try {
    await supabase.functions.invoke('push-send', { body: payload });
  } catch {
    // silent — push 실패는 critical path 아님
  }
}
